import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Funcionario } from '../../api.service';
import { BuscaPesquisavelComponent } from '../../shared/busca-pesquisavel.component';
import { ServicoBuscaCadastro } from '../../shared/servico-busca-cadastro';
import { pedidoFeriasAdminValido } from './regras-solicitacao-ferias-admin';

@Component({
  selector: 'app-modal-solicitacao-ferias',
  standalone: true,
  imports: [CommonModule, FormsModule, BuscaPesquisavelComponent],
  templateUrl: './modal-solicitacao-ferias.component.html',
  styleUrls: ['../../shared/modal-pesquisa-lista.component.css', './modal-solicitacao-ferias.component.css']
})
export class ModalSolicitacaoFeriasComponent implements OnChanges {
  @Input() aberta = false;
  @Input() salvando = false;
  @Input() funcionarios: Funcionario[] = [];

  @Output() fechar = new EventEmitter<void>();
  @Output() salvar = new EventEmitter<{ funcionarioId: string; dataInicio: string; dataFim: string }>();

  busca = '';
  funcionarioId = '';
  dataInicio = '';
  dataFim = '';

  constructor(readonly buscaCadastro: ServicoBuscaCadastro) {}

  rotuloServidor = (item: unknown) => this.buscaCadastro.rotuloFuncionario(item);
  detalheServidor = (item: unknown) => this.buscaCadastro.detalheFuncionario(item);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['aberta'] && this.aberta) {
      this.reiniciar();
    }
  }

  get funcionariosFiltrados() {
    return this.buscaCadastro.filtrarFuncionarios(this.funcionarios, this.busca, this.funcionarioId);
  }

  get servidorSelecionado() {
    return this.funcionarios.find(item => item.id === this.funcionarioId);
  }

  get formularioValido() {
    return pedidoFeriasAdminValido(this.funcionarioId, this.dataInicio, this.dataFim);
  }

  selecionarServidor(item: unknown) {
    const servidor = item as Funcionario;
    this.funcionarioId = servidor.id || '';
    this.busca = this.buscaCadastro.rotuloFuncionario(servidor);
  }

  confirmar() {
    if (!this.formularioValido || this.salvando) {
      return;
    }
    this.salvar.emit({
      funcionarioId: this.funcionarioId,
      dataInicio: this.dataInicio,
      dataFim: this.dataFim
    });
  }

  private reiniciar() {
    this.busca = '';
    this.funcionarioId = '';
    this.dataInicio = '';
    this.dataFim = '';
  }
}
